import './style.scss';
document.addEventListener('DOMContentLoaded', function () {
    // 画像ズーム
    const zoomTargets = document.querySelectorAll('.lpcb-main-visual__img.is-zoomable:not(.swiper-slide *)');
    if (!zoomTargets.length) {
        zoomTargets.forEach(img => {
            const observer = new IntersectionObserver(
                ([entry], observer) => {
                    if (entry.isIntersecting) {
                        img.classList.add('is-zooming');
                        observer.unobserve(img);
                    }
                },
                { threshold: 0.7 }
            );
            observer.observe(img);
        });
    }

    // 動画の遅延ロード（デバイス表示対応）
    function loadMainVisualVideos() {
        var videos = document.querySelectorAll(
            '.wp-block-lpc-blocks-main-visual-v2 .lpcb-main-visual__media[data-src]'
        );
        var width = window.innerWidth;

        videos.forEach(function (video) {
            // すでに src が付いているなら何もしない
            if (video.getAttribute('src')) {
                return;
            }
            // data-src がなければ何もしない
            var src = video.getAttribute('data-src');
            if (!src) {
                return;
            }
            // この video を含んでいるメインビジュアルブロック
            var wrapper = video.closest('.wp-block-lpc-blocks-main-visual-v2');

            // デバイス非表示クラス
            var isHidePc = wrapper.classList.contains('lpcb-hide-pc');
            var isHideTablet = wrapper.classList.contains('lpcb-hide-tablet');
            var isHideSp = wrapper.classList.contains('lpcb-hide-sp');

            // 幅からデバイス帯を判定
            var isPcWidth = width >= 992;
            var isTabletWidth = width >= 768 && width <= 991;
            var isSpWidth = width <= 767;

            // 今のデバイス幅で非表示なら読み込まない
            if (isPcWidth && isHidePc) {
                return;
            }
            if (isTabletWidth && isHideTablet) {
                return;
            }
            if (isSpWidth && isHideSp) {
                return;
            }
            // ここまで来たら表示対象なので src をセット
            video.setAttribute('src', src);
            video.load();
        });
    }
    // 初回実行
    loadMainVisualVideos();

    // リサイズ時再判定
    window.addEventListener('resize', function () {
        loadMainVisualVideos();
    });
});
